import type { ResponseRatioItem } from '@/app/types/Dashboard';

import { roundPercentagesToTotal } from '@/app/utils/number';

const defaultOptions: Highcharts.Options = {
	credits: {
		enabled: false,
	},
	chart: {
		type: 'pie',
		plotBackgroundColor: undefined,
		plotBorderWidth: 0,
		plotShadow: false,
		margin: 0,
		borderRadius: 0,
		height: 115,
		width: 115,
	},

	title: {
		text: '0',
		align: 'center',
		verticalAlign: 'middle',
		style: {
			padding: '0px',
			margin: '0px',
			color: '#4b5062',
			fontFamily: 'Graphik-Semibold',
			fontSize: '25px',
		},
	},
	tooltip: {
		pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>',
		enabled: false,
	},
	accessibility: {
		point: {
			valueSuffix: '%',
		},
		enabled: false,
	},
	legend: {
		align: 'left',
		layout: 'vertical',
		enabled: false,
		useHTML: true,
		squareSymbol: false,
		symbolWidth: 0,
		symbolRadius: 0,
	},
	plotOptions: {
		pie: {
			borderWidth: 0,
			dataLabels: {
				enabled: true,
				distance: 0,
				style: {
					fontWeight: 'bold',
					color: 'white',
				},
			},
			center: ['50%', '50%'],
			size: 115,
			enableMouseTracking: false,
		},
	},
	series: [],
};

export const Chart = {
	toResponseRatioOptions: (data: ResponseRatioItem) => {
		const { accepted = 0, rejected: declined = 0, unanswered = 0, total = 0 } = data;

		const rounded = roundPercentagesToTotal([
			accepted / total || 0,
			declined / total || 0,
			unanswered / total || 0,
		]);

		return {
			...defaultOptions,
			title: {
				text: `${rounded[0]}%`,
				align: 'center',
				verticalAlign: 'middle',
				style: {
					padding: '0px',
					margin: '0px',
					color: '#1ae5b2',
					fontFamily: 'Graphik-Semibold',
					fontSize: '25px',
				},
			},
			series: [
				{
					type: 'pie',
					innerSize: '70%',
					showInLegend: true,
					data: [
						{
							name: 'Accepted',
							y: rounded[0],
							dataLabels: {
								enabled: false,
							},
							color: '#1ae5b2',
						},
						{
							name: 'Declined',
							y: rounded[1],
							dataLabels: {
								enabled: false,
							},
							color: '#ad012d',
						},
						{
							name: 'No Response',
							y: rounded[2],
							dataLabels: {
								enabled: false,
							},
							color: '#ea6200',
						},
					],
				},
			],
		};
	},
};
